import { FC } from 'react'

import useMenusStore from 'src/stores/useMenusStore'
import SidebarProductsCategory from './SidebarProductsCategory'

const SidebarProducts: FC = () => {
  const menus = useMenusStore(s => s.menus)
  if (!menus.length) {
    return null
  }
  return (
    <div className="flex flex-col overflow-x-hidden overflow-y-auto pt-2">
      {menus.map(category => (
        <SidebarProductsCategory key={category.id} category={category} />
      ))}
    </div>
  )
}

export default SidebarProducts
